import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { BsDot } from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import DashboardUtils from "../../../utils/DashboardUtils";
import DashboardNavGroup from "./DashboardNavGroup";
import DashboardNavItem from "./DashboardNavItem";
import DashboardNavLink from "./DashboardNavLink";

const persistCollapseOpen = (location, item) => {
  return location && checkPathInChildren(item, location.pathname);
};

const checkPathInChildren = (parent, url) => {
  if (!parent.children) {
    return null;
  }

  for (let i = 0; i < parent.children.length; i++) {
    if (parent.children[i].children) {
      if (checkPathInChildren(parent.children[i], url)) {
        return parent.key;
      }
    }

    if (
      parent.children[i].url === url ||
      url.includes(parent.children[i].url)
    ) {
      return parent.key;
    }
  }

  return null;
};

const DashboardNavCollapse = (props) => {
  const { item, location } = props;
  const { children, key, title } = item;
  const [open, setOpen] = useState(false);
  const [activeKey, setActiveKey] = useState(() =>
    persistCollapseOpen(location, item)
  );

  useEffect(() => {
    if (persistCollapseOpen(location, item)) {
      setActiveKey(activeKey);
      setOpen(true);
      // console.log("ok", persistCollapseOpen(location, item));
    } else {
      setActiveKey(null);
      // console.log("test", activeKey, persistCollapseOpen(location, item));
    }
  }, [location, item, key, activeKey]);

  const toggle = (e) => {
    e.stopPropagation();
    // console.log(key);
    setOpen(!open);
  };

  const userRole = useSelector(({ auth }) => auth.user.role);
  if (!DashboardUtils.hasPermission(item.auth, userRole)) {
    return null;
  }

  return (
    <div>
      {children && (
        <Accordion defaultActiveKey={activeKey}>
          <Card className="border-0">
            <Accordion.Toggle
              as={Card.Header}
              className="cu-bg-blue-dark cu-bg-blue-dark-hover text-white d-flex justify-content-between align-items-center cursor-pointer rounded-0 pl-3"
              eventKey={key}
              onClick={toggle}
            >
              <span className={clsx(item.isChild && "ml-3")}>
                <BsDot />
                {/* <Icon className="mr-2 align-middle cu-text-md">{icon}</Icon>{" "} */}
                {title}
              </span>{" "}
              {open ? (
                <IoIosArrowUp className="mr-3" />
              ) : (
                <IoIosArrowDown className="mr-3" />
              )}
            </Accordion.Toggle>
            <Accordion.Collapse className="cu-bg-blue-dark-2" eventKey={key}>
              <React.Fragment>
                {children.map((item) => (
                  <React.Fragment key={item.id}>
                    {item.type === "group" && <DashboardNavGroup item={item} />}

                    {item.type === "collapse" && <NavCollapse item={item} />}

                    {item.type === "item" && <DashboardNavItem item={item} />}

                    {item.type === "link" && <DashboardNavLink item={item} />}
                  </React.Fragment>
                ))}
              </React.Fragment>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      )}
    </div>
  );
};

const NavCollapse = withRouter(React.memo(DashboardNavCollapse));

export default NavCollapse;
